import { Theme } from "@remo-co/ui-core/src/types";
import { makeStyles } from "@remo-co/ui-core/src/utils/makeStyles";

export const useStyles = makeStyles<Theme>((theme) => ({
  banner: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center",
    cursor: "pointer",
    height: 55,
    color: theme.palette.text.primary,
  },
  body: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  message: {
    width: 250,
    display: "flex",
  },
  guestName: {
    width: 100,
    textOverflow: "ellipsis",
    overflow: "hidden",
    whiteSpace: "nowrap",
  },
  viewButton: {
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(1),
    whiteSpace: "nowrap",
    height: "28px",
  },
  blackButton: {
    color: "#000",
    borderColor: "#000",
  },
  closeButton: {
    marginLeft: theme.spacing(1),
  },
  userPresence: {
    marginRight: theme.spacing(1),
    justifyContent: "center",
    alignItems: "center",
    border: "none",
    "& svg": {
      backgroundColor: "#ededed",
      padding: theme.spacing(1),
      borderRadius: "50%",
    },
  },
  dark: {
    marginLeft: theme.spacing(1.5),
    "& .MuiTypography-body1": {
      color: "var(--White-op-090)",
    },
    "& $closeBtn": {
      color: "var(--White-op-090)",
    },
    "& $viewBtn": {
      backgroundColor: "var(--EventsDarkBlack)",
      borderColor: "var(--White-op-090)",
      color: "var(--White-op-090)",
    },
    "& .MuiButton-contained": {
      backgroundColor: "var(--CornflowerBlue)",
    },
  },
}));
